export default function Contact() {
  return (
    <>
      <section className="relative bg-gradient-to-b from-white to-gray-100 py-16 scroll-animate">
        <div className="container mx-auto px-5">

          <div className="text-center mb-10">
            <h1 className="text-4xl font-semibold text-gray-900">Kontak Kami</h1>
            <p className="text-gray-600 max-w-2xl mx-auto mt-2">
              Silakan hubungi kami melalui informasi berikut. Lokasi kami dapat ditemukan melalui peta di bawah.
            </p>
          </div>
          <div className="relative max-w-6xl mx-auto rounded-3xl overflow-hidden shadow-2xl">

            <div className="h-[500px] w-full">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d31718.81155753896!2d106.7919803!3d-6.4131279!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69eb0161f60213%3A0x955cf2317239a1cf!2sPemerintah%20Kota%20Depok!5e0!3m2!1sid!2sid!4v1761991695455!5m2!1sid!2sid"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-md p-8 rounded-2xl shadow-xl w-[360px]">
              <h2 className="text-xs font-semibold text-gray-800 tracking-widest mb-2">
                ADDRESS
              </h2>
              <p className="text-gray-700 mb-5">
                Pemerintah Kota Depok, Jawa Barat, Indonesia
              </p>

              <h2 className="text-xs font-semibold text-gray-800 tracking-widest mb-2">
                EMAIL
              </h2>
              <p className="text-indigo-500 mb-5">info@gizimonmbg.id</p>

              <h2 className="text-xs font-semibold text-gray-800 tracking-widest mb-2">
                PHONE
              </h2>
              <p className="text-gray-700">021-555-4321</p>
            </div>

          </div>

        </div>
      </section>
    </>
  );
}
